import type { Comment, Reply } from '@getaccept/lib-shared/src/contextual-comments/types/comment';
import type { CommentReadEvent } from '../types/comment-read-event';

export class CommentsHelper {
  static readEventsAreEqual(event1: CommentReadEvent, event2: CommentReadEvent) {
    return (
      event1.participant.userId === event2.participant.userId &&
      event1.participant.recipientId === event2.participant.recipientId &&
      event1.timestamp === event2.timestamp
    );
  }

  static updateComment(commentPartial: Partial<Comment>, commentId: string, comments: Comment[]) {
    return comments.map(comment =>
      comment.id === commentId ? { ...comment, ...commentPartial } : comment
    );
  }

  static addReply(reply: Reply, commentId: string, comments: Comment[]) {
    return comments.map(comment =>
      comment.id === commentId ? { ...comment, replies: [...comment.replies, reply] } : comment
    );
  }

  static removeReply(replyId: string, commentId: string, comments: Comment[]) {
    return comments.map(comment =>
      comment.id === commentId
        ? { ...comment, replies: comment.replies.filter(({ id }) => id !== replyId) }
        : comment
    );
  }

  static updateReply(
    replyPartial: Partial<Reply>,
    replyId: string,
    commentId: string,
    comments: Comment[]
  ) {
    return comments.map(comment =>
      comment.id === commentId
        ? {
            ...comment,
            replies: comment.replies.map(reply =>
              reply.id === replyId ? { ...reply, ...replyPartial } : reply
            ),
          }
        : comment
    );
  }

  static addRead(readEvent: CommentReadEvent, commentId: string, comments: Comment[]) {
    return comments.map(comment =>
      comment.id === commentId ? { ...comment, reads: [...comment.reads, readEvent] } : comment
    );
  }

  static removeRead(readEvent: CommentReadEvent, commentId: string, comments: Comment[]) {
    return comments.map(comment =>
      comment.id === commentId
        ? {
            ...comment,
            reads: comment.reads.filter(
              event => !CommentsHelper.readEventsAreEqual(event, readEvent)
            ),
          }
        : comment
    );
  }

  static addReplyRead(
    readEvent: CommentReadEvent,
    replyId: string,
    commentId: string,
    comments: Comment[]
  ) {
    return comments.map(comment =>
      comment.id === commentId
        ? {
            ...comment,
            replies: comment.replies.map(reply =>
              reply.id === replyId ? { ...reply, reads: [...reply.reads, readEvent] } : reply
            ),
          }
        : comment
    );
  }

  static removeReplyRead(
    readEvent: CommentReadEvent,
    replyId: string,
    commentId: string,
    comments: Comment[]
  ) {
    return comments.map(comment =>
      comment.id === commentId
        ? {
            ...comment,
            replies: comment.replies.map(reply =>
              reply.id === replyId
                ? {
                    ...reply,
                    reads: reply.reads.filter(
                      event => !CommentsHelper.readEventsAreEqual(event, readEvent)
                    ),
                  }
                : reply
            ),
          }
        : comment
    );
  }
}
